/** Admin platform-staff — list, set role, revoke. */
import { apiDelete, apiGet, apiPut } from '../client.js';
import type { PlatformStaff, PlatformStaffRole } from '../types.js';

export function listPlatformStaff(): Promise<PlatformStaff[]> {
  return apiGet<PlatformStaff[]>('/api/v1/admin/platform-staff');
}

export function setPlatformStaffRole(
  staffId: string,
  role: PlatformStaffRole,
): Promise<PlatformStaff> {
  return apiPut<PlatformStaff>(
    `/api/v1/admin/platform-staff/${encodeURIComponent(staffId)}`,
    { role },
  );
}

export function revokePlatformStaff(staffId: string): Promise<void> {
  return apiDelete<void>(
    `/api/v1/admin/platform-staff/${encodeURIComponent(staffId)}`,
  );
}
